import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LandingPage from './LandingPage';
import Details from './Details';
import MatchingTool from './MatchingTool';
import EmailTool from './EmailTool';
import ComposeEmailPage from './ComposeEmailPage';

/* lightweight iframe pages */
const IframePage = ({ src, title }) => (
  <div className="p-6">
    <iframe
      className="airtable-embed w-full"
      src={src}
      frameBorder="0"
      width="100%"
      height="600"
      style={{ background: 'transparent', border: '1px solid #ccc' }}
      title={title}
    />
  </div>
);

const DatabasePage   = () => <IframePage src="https://airtable.com/embed/appP95LLqjrsqVMGg/shrcvDzsIrl45VnS9?viewControls=on"   title="Airtable Database" />;
const StateView      = () => <IframePage src="https://airtable.com/embed/appP95LLqjrsqVMGg/shrw0ieQfCbLQ160V?viewControls=on"   title="State View" />;
const GenderView     = () => <IframePage src="https://airtable.com/embed/appP95LLqjrsqVMGg/shrokdRh5J6TmWuUv?viewControls=on"   title="Gender View" />;
const ResearchView   = () => <IframePage src="https://airtable.com/embed/appP95LLqjrsqVMGg/shrIsMan7I34KjmVE?viewControls=on"   title="Research Experience" />;
const McatView       = () => <IframePage src="https://airtable.com/embed/appP95LLqjrsqVMGg/shrRsZDiy4DCDj7Vj?viewControls=on"   title="MCAT View" />;
const SchoolView     = () => <IframePage src="https://airtable.com/embed/appP95LLqjrsqVMGg/shrMJqv6Rxz5vseiO?viewControls=on"   title="School View" />;
const TypeSchoolView = () => <IframePage src="https://airtable.com/embed/appP95LLqjrsqVMGg/shrujrTR0MUDX1i1a?viewControls=on" title="Type of School View" />;

// client-side passcode gate (simple)
const PASSCODE = process.env.REACT_APP_PASSCODE;
console.log("🔑 PASSCODE is:", PASSCODE);

function PasscodeGate({ children }) {
  const [entry, setEntry] = useState('');
  const [ok, setOk] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();
    if (entry === PASSCODE) {
      setOk(true);
    } else {
      alert('❌ Incorrect passcode');
      setEntry('');
    }
  };

  if (!ok) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md space-y-4">
          <label className="block">
            <span className="text-gray-700">Enter Passcode</span>
            <input
              type="password"
              value={entry}
              onChange={e => setEntry(e.target.value)}
              className="mt-1 block w-full border rounded px-2 py-1 focus:outline-none"
            />
          </label>
          <button
            type="submit"
            className="w-full bg-red-600 text-white py-2 rounded hover:bg-red-700"
          >
            Unlock
          </button>
        </form>
      </div>
    );
  }

  return children;
}

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [airtableOpen, setAirtableOpen] = useState(false);
  const closeMenus = () => { setMenuOpen(false); setAirtableOpen(false); };

  return (
    <PasscodeGate>
      <Router>
        {/* Top Bar */}
        <nav className="flex items-center justify-between bg-[#8C1515] px-6 py-4 shadow">
          <Link to="/" onClick={closeMenus} className="text-2xl font-extrabold text-white hover:underline">
            Stanford Pathways
          </Link>
          <div className="relative">
            <button aria-label="Toggle menu" onClick={() => setMenuOpen(!menuOpen)} className="focus:outline-none">
              <svg className="h-10 w-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 w-64 rounded-md border border-white bg-white text-gray-800 shadow-xl z-50">
                <Link to="/" className="block px-4 py-3 hover:bg-gray-100" onClick={closeMenus}>Home</Link>
                <Link to="/matching" className="block px-4 py-3 hover:bg-gray-100" onClick={closeMenus}>Matching Tool</Link>
                <Link to="/email" className="block px-4 py-3 hover:bg-gray-100" onClick={closeMenus}>Email Tool</Link>
                <div className="border-t border-gray-200">
                  <button onClick={() => setAirtableOpen(!airtableOpen)} className="w-full px-4 py-3 text-left hover:bg-gray-100">
                    Airtable ▸
                  </button>
                  {airtableOpen && (
                    <div className="pl-6 pb-3">
                      <Link to="/database" className="block px-2 py-2 text-sm hover:bg-gray-100" onClick={closeMenus}>Database</Link>
                      <Link to="/state-view" className="block px-2 py-2 text-sm hover:bg-gray-100" onClick={closeMenus}>State View</Link>
                      <Link to="/gender-view" className="block px-2 py-2 text-sm hover:bg-gray-100" onClick={closeMenus}>Gender View</Link>
                      <Link to="/school-view" className="block px-2 py-2 text-sm hover:bg-gray-100" onClick={closeMenus}>School View</Link>
                      <Link to="/type-school-view" className="block px-2 py-2 text-sm hover:bg-gray-100" onClick={closeMenus}>Type of School View</Link>
                      <Link to="/research-view" className="block px-2 py-2 text-sm hover:bg-gray-100" onClick={closeMenus}>Research Experience</Link>
                      <Link to="/mcat-view" className="block px-2 py-2 text-sm hover:bg-gray-100" onClick={closeMenus}>MCAT View</Link>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </nav>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/details/:id" element={<Details />} />
          <Route path="/matching" element={<MatchingTool />} />
          <Route path="/email" element={<EmailTool />} />

          {/* Airtable embeds */}
          <Route path="/database" element={<DatabasePage />} />
          <Route path="/state-view" element={<StateView />} />
          <Route path="/gender-view" element={<GenderView />} />
          <Route path="/school-view" element={<SchoolView />} />
          <Route path="/type-school-view" element={<TypeSchoolView />} />
          <Route path="/research-view" element={<ResearchView />} />
          <Route path="/mcat-view" element={<McatView />} />

          {/* Email composer */}
          <Route path="/compose/:recordId" element={<ComposeEmailPage />} />
        </Routes>
      </Router>
    </PasscodeGate>
  );
}
